import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

// ─── Component ────────────────────────────────────────────────────────────────

export function PricingDisclaimer() {
  return (
    <section className="bg-white py-12 md:py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RichTextContent
          path="pricingdisclaimer.body"
          label="Pricing Disclaimer Body"
          defaultValue={
            '<p><strong>Clear Pricing Information:</strong> We believe in providing clear and upfront pricing to help you plan with confidence. Prices shown reflect base rent only. To estimate your monthly total, add your base rent to the Essentials and any Personalized Add Ons you select.</p>'
          }
          as="div"
          className="pricing-disclaimer-body font-body text-sm md:text-base text-[var(--vibe-color-text)] leading-relaxed"
        />
      </div>

      <style>{`
        .pricing-disclaimer-body p {
          margin-bottom: 0.5rem;
        }
        .pricing-disclaimer-body p:last-child {
          margin-bottom: 0;
        }
        .pricing-disclaimer-body a {
          text-decoration: underline;
          text-underline-offset: 2px;
          color: var(--vibe-color-text);
          font-weight: 600;
          transition: color 0.2s ease;
        }
        .pricing-disclaimer-body a:hover {
          color: var(--vibe-color-secondary);
        }
        .pricing-disclaimer-body strong {
          font-weight: 700;
        }
      `}</style>
    </section>
  );
}

// ─── Content Schema ───────────────────────────────────────────────────────────

export const contentSchema: ComponentContentSchema = {
  slot: 'PricingDisclaimer',
  displayName: 'Pricing Disclaimer',
  tokens: {
    'pricingdisclaimer.body': {
      label: 'Pricing Disclaimer Body',
      type: 'richtext',
      defaultValue:
        '<p><strong>Clear Pricing Information:</strong> We believe in providing clear and upfront pricing to help you plan with confidence. Prices shown reflect base rent only. To estimate your monthly total, add your base rent to the Essentials and any Personalized Add Ons you select.</p>',
    },
  },
};

(PricingDisclaimer as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default PricingDisclaimer;
